import { render, staticRenderFns } from "./deposits.vue?vue&type=template&id=2bd5d3a5&"
import script from "./deposits.vue?vue&type=script&lang=js&"
export * from "./deposits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports